import React, { PureComponent } from 'react';
import { intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Shell from '@shared/containers/Shell';
import InnerHeader from '@shared/containers/InnerHeader';

import WhiteContainer from '@shopDetails/components/WhiteContainer';
import ShopInfoShopCard from './components/Card';
import Map from './components/Map';
import PaymentMethods from './components/PaymentMethods';
import GeneralInfo from './components/GeneralInfo';
import Schedule from './components/Schedule';

import messages from './messages';
import connect from './connect';

const Container = styled.div`
  margin: ${({ theme }) => theme.constants.lateralSpace};
`;

class ShopInfo extends PureComponent {
  state = {
    isMapExpanded: false,
    isClient: false,
  };

  componentDidMount() {
    this.setState({ isClient: true });
  }

  toggleMap = () =>
    this.setState(({ isMapExpanded }) => ({ isMapExpanded: !isMapExpanded }));

  render() {
    const {
      shop,
      schedules,
      intl: { formatMessage },
      hasFetchedShop,
      needBromatologyCheck,
      timeFormat,
    } = this.props;
    const { isMapExpanded, isClient } = this.state;

    const shouldShowShopInfo = hasFetchedShop && !!shop && isClient;

    return (
      <Shell
        showOverlaySpinner={isClient && !hasFetchedShop}
        isModal
        header={<InnerHeader label={formatMessage(messages.title)} isModal />}
      >
        <WhiteContainer>
          {shouldShowShopInfo && (
            <Container>
              <Map
                latitude={shop.latitude}
                longitude={shop.longitude}
                isMapExpanded={isMapExpanded}
                onClick={this.toggleMap}
              />

              <ShopInfoShopCard shop={shop} />

              {needBromatologyCheck && <GeneralInfo />}

              <PaymentMethods paymentMethods={shop.paymentMethods} />

              {schedules && (
                <Schedule schedule={schedules} timeFormat={timeFormat} />
              )}
            </Container>
          )}
        </WhiteContainer>
      </Shell>
    );
  }
}

ShopInfo.propTypes = {
  hasFetchedShop: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
  shop: PropTypes.object,
  schedules: PropTypes.array,
  timeFormat: PropTypes.string.isRequired,

  // withRouter
  match: PropTypes.shape({
    params: PropTypes.shape({
      city: PropTypes.string,
      restaurant: PropTypes.string,
    }),
  }).isRequired,
  needBromatologyCheck: PropTypes.bool.isRequired,
};

export default connect(ShopInfo);
